import React from 'react';
import { ChartBarIcon } from '@heroicons/react/24/outline';

const Card = ({ 
  title, 
  count, 
  colorClass,
  icon: Icon,
  onAction,
  onDailyFollowUp,
  showSubtitle = true
}) => {
  const IconComponent = Icon || ChartBarIcon;

  return (
    <div 
      className={`${colorClass.bg} text-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-xl`}
      style={{ width: "220px", height: "120px" }}
    >
      <div className="p-4">
        <div className="flex items-center justify-between mb-1">
          <h3 className="text-md text-bold font-bold opacity-200">{title}</h3>
          <div className="bg-white/5 p-2 rounded-lg backdrop-blur-sm">
            <IconComponent className="w-5 h-5" />
          </div>
        </div>
        
        <div className="mb-1">
          <p className="text-2xl font-bold mb-0.5">{count}</p>

          {/* ✅ CONDITIONAL */}
          {showSubtitle && (
            <p className="text-xs opacity-75">Total entries</p>
          )}
        </div>

        {onAction && (
          <button
            onClick={onAction}
            className={`w-full ${colorClass.buttonBg} hover:opacity-90 text-white py-1.5 rounded-md font-medium text-sm transition-all duration-200 shadow`}
          >
            View Details
          </button>
        )}
      </div>
    </div>
  );
};

export default Card;